module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 2);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  e.exports = r(3)();
}, function (e, t, r) {
  "use strict";

  r.r(t), r.d(t, "HouxProvider", function () {
    return s;
  }), r.d(t, "useHoux", function () {
    return l;
  });
  var n = r(0),
      o = r.n(n),
      u = r(1),
      i = r.n(u);

  function c(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var r = [],
          n = !0,
          o = !1,
          u = void 0;

      try {
        for (var i, c = e[Symbol.iterator](); !(n = (i = c.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, u = e;
      } finally {
        try {
          n || null == c.return || c.return();
        } finally {
          if (o) throw u;
        }
      }

      return r;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  var a = Object(n.createContext)({}),
      f = function f(e, t) {
    var r = function (e) {
      return function (t, r) {
        var n = {};
        return Object.entries(e).forEach(function (e) {
          var o = c(e, 2),
              u = o[0],
              i = o[1];
          n[u] = i(t && t[u], r);
        }), n;
      };
    }(e),
        o = r(void 0, {
      type: "STATE_INIT"
    }),
        u = c(Object(n.useReducer)(r, o), 2),
        i = u[0],
        a = u[1];

    return {
      state: i,
      dispatch: function e(r) {
        return t && r.type && console.info(r), "function" == typeof r ? r(e, i) : a(r);
      }
    };
  },
      s = function s(e) {
    var t = e.children,
        r = e.reducers,
        n = e.logDispatchedActions,
        u = f(r, n);
    return o.a.createElement(a.Provider, {
      value: u
    }, t);
  };

  s.propTypes = {
    children: i.a.element.isRequired,
    logDispatchedActions: i.a.bool,
    reducers: i.a.objectOf(i.a.func).isRequired
  }, s.defaultProps = {
    logDispatchedActions: !1
  };

  var l = function l() {
    return Object(n.useContext)(a);
  };
}, function (e, t, r) {
  "use strict";

  var n = r(4);

  function o() {}

  function u() {}

  u.resetWarningCache = o, e.exports = function () {
    function e(e, t, r, o, u, i) {
      if (i !== n) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var r = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: u,
      resetWarningCache: o
    };
    return r.PropTypes = r, r;
  };
}, function (e, t, r) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}]);